
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerClass()
    export class IcStockReceiveGrid extends Serenity.EntityGrid<IcStockReceiveRow, any> {
        protected getColumnsKey() { return IcStockReceiveColumns.columnsKey; }
        protected getDialogType() { return IcStockReceiveDialog; }
        protected getIdProperty() { return IcStockReceiveRow.idProperty; }
        protected getInsertPermission() { return IcStockReceiveRow.insertPermission; }
        protected getLocalTextPrefix() { return IcStockReceiveRow.localTextPrefix; }
        protected getService() { return IcStockReceiveService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            
        }
        protected getButtons() {
            var buttons = super.getButtons();

            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: IcStockReceiveService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;

                    },
                }
            );

            buttons.push({
                title: "Import Detail From Excel",
                hint: "Import Stock Receive Detail from Excel template",
                cssClass: "upload-IcStockReceiveDt-template-button",
                icon: "fa-cloud-upload-alt",
                separator: true,
                onClick: () => {
                    const dialog = new Common.ImportIcStockReceiveDtDialog()
                    this.initDialog(dialog)
                    dialog.importState = () => {
                        Q.notifySuccess("Import from Excel successfully.")
                        this.refresh()
                    }
    
                    dialog.dialogOpen()
                }
            })

            buttons.push({
                title: "Download Detail Template",
                hint: "Download Excel template for Stock Receive Detail import",
                cssClass: "download-IcStockReceiveDt-template-button",
                icon: "fa-download",
                separator: true,
                onClick: () => {
                    window.location.href = Q.resolveUrl("~/Services/Csi/DownloadImportIcStockReceiveDtTemplate");
                }
            })


            return buttons;
        }
        protected getColumns() {
            var columns = super.getColumns();
    
            columns.splice(1, 0, {
                id: 'Print CountApprove',
                field: null,
                name: '',
                cssClass: 'align-center',
                format: ctx => {
                    return '<a class="inline-action print-countapprove" title="countapprove">' +
                    '<i class="fa fa-file-pdf-o text-red"></i></a>';
                },
                width: 30,
                minWidth: 30,
                maxWidth: 30
            });
    
            return columns;
        }
    
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);
    
            // if (e.isDefaultPrevented())
            //     return;
    
            var item = this.itemAt(row);
            var target = $(e.target);

            
            if (target.parent().hasClass('inline-action'))
                target = target.parent();
    
            if (target.hasClass('inline-action')) {
                e.preventDefault();
    
                if (target.hasClass('print-countapprove')) {
                    const request = this.getView().params as IcStockReceiveData
                    request.SysDocNo = item.SysDocNo

                    request.Header = Q.tryFirst(IcStockReceiveRow.getLookup().items, x=> x.SysDocNo == item.SysDocNo)
                    // IcStockApproveDtRow
                    let fg = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 26 && x.SysFg > 0)
                    let shop = item.SysDocNo.substring(2, 7) 
                    console.log(shop)
                    let s = Q.tryFirst(InitialData.PsShopRow.getLookup().items, x=> x.ShopId == shop)
                    if (fg != null && s != null) { 
                        request.BizName = s.ShopRegName
                        request.BizAddressLine1 = s.ShopRegAddressLine1
                        request.BizAddressLine2 = s.ShopRegAddressLine2
                        request.BizAddressLine3 = s.ShopRegAddressLine3
                        request.TaxId = s.ShopTaxId
                    } else {

                        let q = Q.tryFirst(Administration.CsParaRow.getLookup().items, x=> x.Id == 1)
                        request.BizName = q.BizName
                        request.BizAddressLine1 = q.TaxInvAddrLine1
                        request.BizAddressLine2 = q.TaxInvAddrLine2
                        request.BizAddressLine3 = q.TaxInvAddrLine3
                        request.TaxId = q.BizName
                    }
                   
                    let p = Q.tryFirst(Lookups.VwPsParaRow.getLookup().items, x => x.Id == 1)

                        if(p != null){
                            let vp = window.location.href.replace("#", "")
                            console.log(vp)
                            let ap = vp.replace("/Inventory/IcStockReceive","")
                            request.URLpic = ap + "/upload/" +  p.ShopLogoOnFrontScreen 
                        }else{
                            request.URLpic = "https://" + window.location.host + "/upload/info.jpg"
                        }
                    console.log(request)
                    
                    Q.postToService({ service: this.getService() + '/ExportPdf', request: request, target: '_blank' })
                    
                    ;
                }
            }
        }
       

    }
   
}